import React, { useState } from 'react';
import PropTypes from 'prop-types';

// material-ui
import { Button, CircularProgress, DialogContent, Stack, Typography } from '@mui/material';

// project import
import Avatar from 'components/@extended/Avatar';

// assets
import { DeleteFilled } from '@ant-design/icons';

// ==============================|| DELETE - MODAL||============================== //

export default function DeleteModal({
    title,
    body,
    onClose,
    onDelete,
    custom,
    actionLabel = 'Delete',
    actionInProgressLabel
}) {
    const [deleting, setDeleting] = useState(false);
    const inProgressLabel =
        actionInProgressLabel || `${actionLabel.replace(/e$/i, '')}ing...`;

    const handleDelete = async () => {
        setDeleting(true);
        try {
            if (onDelete) {
                await onDelete();
            }

            onClose();
        } finally {
            setDeleting(false);
        }
    };

    // TODO: Create a reusable modal content component
    return (
        <>
            <DialogContent sx={{ mt: 2, my: 1 }}>
                <Stack alignItems="center" spacing={3.5}>
                    <Avatar
                        color="error"
                        sx={{ width: 72, height: 72, fontSize: '1.75rem' }}
                    >
                        <DeleteFilled />
                    </Avatar>
                    <Stack spacing={2}>
                        <Typography variant="h4" align="center">
                            {body}
                        </Typography>
                        <Typography align="center">
                            {custom && custom.prefix
                                ? custom.prefix
                                : `Do you really want to ${actionLabel.toLowerCase()} `}
                            <Typography
                                variant="subtitle1"
                                component="span"
                                textTransform={'capitalize'}
                            >
                                {' '}
                                &quot;{title}&quot;{' '}
                            </Typography>
                            {custom && custom.postfix
                                ? custom.postfix
                                : `? This action cannot be undone.`}
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ width: 1 }}>
                        <Button
                            fullWidth
                            onClick={onClose}
                            color="secondary"
                            variant="outlined"
                            disabled={deleting}
                        >
                            Cancel
                        </Button>
                        <Button
                            fullWidth
                            color="error"
                            variant="contained"
                            onClick={handleDelete}
                            disabled={deleting}
                            autoFocus
                        >
                            {deleting ? (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <CircularProgress size={18} color="inherit" />
                                    <span>{inProgressLabel}</span>
                                </Stack>
                            ) : (
                                actionLabel
                            )}
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </>
    );
}

DeleteModal.propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    actionLabel: PropTypes.string,
    actionInProgressLabel: PropTypes.string
};
